import { CanActivateFn } from '@angular/router';

export const canAccessGuard: CanActivateFn = () => {
  const token = localStorage.getItem('token');
  const isFromOnboarding = localStorage.getItem('isFromOnboarding');
  if (isFromOnboarding && token) {
    return true;
  }

  // If token exists → block access
  if (token) {
    return false;
  }

  return true;
};
